// src/router/containers.js

// Quem abre estas telas (TRI-107; o admin passa). Aplicado pelo guard de @/router/permissoes.js,
// que o menu lateral também usa.
const ROLES = ['coordenador_operacional']

const containersBreadCrumb = [
    {
        label: 'Home',
        to: 'Home'
    },
    {
        label: 'Containers',
        to: 'TiposContainers'
    }
]

export default [
    {
        path: '/tipos-containers',
        name: 'TiposContainers',
        component: () => import('@/views/TiposContainers/TipoContainerListPage.vue'),
        meta: {
            roles: ROLES,
            title: 'Tipos de Containers',
            breadcrumb: containersBreadCrumb
        },
    },
    {
        path: '/tipos-containers/novo',
        name: 'TipoContainerNovo',
        component: () => import('@/views/TiposContainers/NovoTipoContainerPage.vue'),
        meta: {
            roles: ROLES,
            title: 'Novo Tipo Container',
            breadcrumb: [
                ...containersBreadCrumb,
                {
                    label: 'Novo Tipo Container',
                    to: 'TipoContainerNovo'
                }
            ]
        }
    },
    {
        path: '/tipos-containers/:id/edit',
        name: 'TipoContainerEdit',
        component: () => import('@/views/TiposContainers/NovoTipoContainerPage.vue'),
        meta: {
            roles: ROLES,
            title: 'Detalhes do tipo container',
            breadcrumb: [
                ...containersBreadCrumb,
                {
                    label: 'Novo Tipo Container',
                    to: 'TipoContainerNovo'
                }
            ]
        }
    }

];
